module.exports = __webpack_public_path__ + "static/app_setting-54aa1d5837a16cd4ca22589a735a4b68.png";